<form autocomplete="off" [formGroup]="innerForm">
    <div class="float-left smart-tag-form-container container" *ngIf="smartTagModel !== null">
        <div class="row">
            <div class="col-md-6 mb-3">
                <cv-dropdown
                        [placeholder]="'Quality'"
                        [optionText]="'label'"
                        [selectedValue]="dropdownInitialValues['viewQuality']"
                        [options]="smartTagViewQualityOptions"
                        (valuesChange)="onDropdownValueChange('viewQuality', $event)">
                </cv-dropdown>
            </div>

            <div class="col-md-6" *ngIf="schemaShouldShowComplexForm">
                <cv-dropdown
                        [placeholder]="'Affect'"
                        [optionText]="'label'"
                        [selectedValue]="dropdownInitialValues['viewAffect']"
                        [options]="smartTagViewAffectOptions"
                        (valuesChange)="onDropdownValueChange('viewAffect', $event)">
                </cv-dropdown>
            </div>
        </div>

        <div class="row">
            <div class="col-md-10">
                <label>Description:</label>
                <textarea name="description"
                          formControlName="description"
                          (keyup)="smartTagModel.description = $event.currentTarget['value'];"
                          id="report-image-description" name="report-image-description" rows="3"
                          cols="50" [maxLength]="150"></textarea>
            </div>
        </div>
    </div>
</form>
